<template>
  <div class="unfinished" :class="{finished: finished}">
          <span class="icon" :class="{complete: finished}" v-text="finished?'':index">
          </span>
    <span class="title" v-text="title"></span>
  </div>
</template>

<script>
  export default{
    name: 'work-item',
    props: {
      index: Number,
      title: String,
      finished: Boolean
    }
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../assets/scss/base.scss';

  .unfinished {
    width: px2rem(602);
    height: px2rem(115);
    margin: px2rem(10) auto 0 auto;
    color: white;
    @include bg-img('../assets/img/teacher/unfinish_bg');

    .icon {
      margin-left: px2rem(30);
      margin-top: px2rem(22);
      display: inline-block;
      height: px2rem(70);
      width: px2rem(70);
      vertical-align: top;
      color: white;
      line-height: px2rem(70);
      text-align: center;
      font-size: px2rem(45);
      @include bg-img('../assets/img/teacher/number_bg');
    }

    .title {
      height: px2rem(115);
      line-height: px2rem(115);
      font-size: px2rem(38);

      font-weight: bold;
    }
  }

  .finished {
    color: #6f4709;
    @include bg-img('../assets/img/teacher/finish_bg');

    .complete {
      @include bg-img('../assets/img/teacher/completed');
    }
  }
</style>



// WEBPACK FOOTER //
// WorkItem.vue?35d3b05a